<div class="text-sm text-600 mb-3">
  Drafts of this page's lead and bio, written by the drafts tool from what we know about the suburb (the places we work with first). Read them against the live text, edit, then accept the lead, the bio or both. Nothing changes on the website until you accept, and then only when the site is next published.
</div>

<div *ngIf="error" class="err text-sm mb-2">{{ error }}</div>
<div *ngIf="message" class="ok text-sm mb-2">{{ message }}</div>
<div *ngIf="loading" class="text-600 text-sm">Loading…</div>

<ng-container *ngIf="!loading">
  <div *ngIf="!waiting.length" class="text-600 text-sm mb-3">No drafts waiting. The drafts tool writes them (conductor-suburb-enricher: <code>drafts</code>).</div>

  <div *ngFor="let d of waiting" class="draft">
    <div class="flex align-items-center justify-content-between gap-2">
      <span class="text-xs text-500">{{ d.model }} · {{ d.generatedAt | date: 'd MMM y, h:mm a' }}</span>
      <span *ngIf="!readOnly && editing?.id !== d.id" class="flex gap-1">
        <button pButton type="button" class="p-button-sm" label="Review" (click)="review(d)"></button>
        <button pButton type="button" class="p-button-sm p-button-text p-button-danger" label="Discard" [disabled]="busy" (click)="discard(d)"></button>
      </span>
    </div>

    <ng-container *ngIf="editing?.id !== d.id">
      <div class="side-by-side">
        <div>
          <div class="lbl">Draft lead <span class="text-500 text-xs">({{ words(d.lead) }} words)</span></div>
          <div class="text">{{ d.lead || '—' }}</div>
        </div>
        <div>
          <div class="lbl">Live intro</div>
          <div class="text live">{{ liveIntro || 'None: the page uses the shared lead.' }}</div>
        </div>
      </div>
      <div class="side-by-side">
        <div>
          <div class="lbl">Draft bio <span class="text-500 text-xs">({{ words(d.bio) }} words)</span></div>
          <div class="text pre">{{ d.bio || '—' }}</div>
        </div>
        <div>
          <div class="lbl">Live body</div>
          <div class="text pre live">{{ liveBody || 'None.' }}</div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="editing?.id === d.id && editing as e" class="review">
      <label class="flex align-items-center gap-2"><input type="checkbox" [(ngModel)]="e.useLead" /> <span class="lbl m-0">Lead → the page's intro</span></label>
      <textarea pInputTextarea [(ngModel)]="e.lead" [disabled]="!e.useLead" rows="4" class="w-full mt-1"></textarea>
      <div class="text-xs text-500">{{ words(e.lead) }} words. Shown as the page's lead under the heading.</div>
      <label class="flex align-items-center gap-2 mt-3"><input type="checkbox" [(ngModel)]="e.useBio" /> <span class="lbl m-0">Bio → the page's body</span></label>
      <textarea pInputTextarea [(ngModel)]="e.bio" [disabled]="!e.useBio" rows="10" class="w-full mt-1"></textarea>
      <div class="text-xs text-500">{{ words(e.bio) }} words. Replaces the page's body{{ liveBody ? ' (it has one now)' : '' }}.</div>
      <div class="flex gap-2 mt-3">
        <button pButton type="button" class="p-button-sm" label="Accept" [disabled]="busy || (!e.useLead && !e.useBio)" (click)="accept()"></button>
        <button pButton type="button" class="p-button-sm p-button-text" label="Cancel" (click)="editing = null"></button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="decided.length">
    <div class="lbl mt-3">Decided</div>
    <div *ngFor="let d of decided" class="text-xs text-500">{{ d.status === 'accepted' ? 'Accepted' : 'Discarded' }} {{ d.decidedAt | date: 'd MMM y' }}{{ d.decidedBy ? ' by ' + d.decidedBy : '' }}: “{{ (d.lead || d.bio || '') | slice: 0:80 }}…”</div>
  </ng-container>
</ng-container>
